export default {
  title: 'Discover',
  official: 'Official updates',
  stage: 'Main stage',
  announcements: 'Announcements',
  offers: 'Promotions',
  jackpot: 'Jackpot news',
  media: 'Media partners',
  empty: 'Nothing here yet',
  // Official-news feed (see pages/Discover/OfficialNews).
  official_author: 'Official Updates',
  post_expand: 'Full text',
  post_collapse: 'Show less',
  post_share: 'Share this post',
  post_copied: 'Post copied',
  post_likes_suffix: ' and {count} others liked this',
  // Announcement centre (see pages/Discover/AnnouncementCenter).
  ann_tab_system: 'System messages',
  ann_tab_latest: 'Latest notices',
  ann_tab_must_read: 'Must read',
  day_today: 'Today',
  day_yesterday: 'Yesterday',
  // Offers hall (see pages/Discover/SpecialOffers). The CTA's wording
  // differs per promo, so each is its own key.
  offer_details: 'Details',
  offer_contact: 'Contact support',
  offer_cta_join: 'Take part',
  offer_cta_claim: 'Claim reward',
  offer_cta_apply: 'Apply now',
};
